import {
    Alert,
    Box,
    Popover,
} from '@mui/material';
import { Trans } from 'react-i18next';

function SubmittedPopover(props) {
    return (
        <>
            <Popover
                {...props}
            >
                <Box sx={{width : '300px', p: 2}}>
                    <Trans ns='dashboardPage' i18nKey={'bereitsFreigegeben'}>
                        Bereits freigegebene Zeiten sind nicht mehr bearbeitbar. Sofern du die Zeiten trotzdem bearbeiten musst, bitte jemanden
                        mit "Reporter" - Zugang um die Aufhebung der Freigabe.
                    </Trans>
                </Box>
            </Popover>
        </>
    );
};

export default SubmittedPopover
